import React, { FC } from 'react'

import { colors, Typography } from '@smarty-nx/ds'

import { content } from './discount-card.content'
import classes from './discount-card.module.scss'
import GroupPlan from '../../static/images/big-data-plans.png'
import ColorButton from '../ColorButton'
import {
  FullWidthContainer,
  HideOnTablet,
  HideSmallDesktopUpwards,
} from '../shared'

export const DiscountCard: FC = () => (
  <FullWidthContainer data-testid="get-money-back-card">
    <div className={classes.wrapper}>
      <div className={classes.leftColumn}>
        <Typography
          component="h2"
          variant="Kollektif/ExtraLarge"
          className={classes.title}
          dataTestId="get-money-back-title"
        >
          {content.title}
        </Typography>
        <HideSmallDesktopUpwards>
          <img src={GroupPlan} alt="" data-testid="get-money-back-image" />
        </HideSmallDesktopUpwards>
        <Typography
          variant="Kollektif/Large"
          className={classes.subtitle}
          dataTestId="get-money-back-subtitle"
        >
          {content.textOne}
          <span className={classes.greenText}>{content.greenText}</span>
          {content.textTwo}
          <span className={classes.yellowText}>{content.yellowText}</span>
          {content.textThree}
        </Typography>
      </div>
      <div className={classes.rightColumn}>
        <HideOnTablet>
          <img src={GroupPlan} alt="" data-testid="get-money-back-image" />
        </HideOnTablet>
        <ColorButton
          href={content.CTALink}
          color={colors['Brand/PrimaryGreen']}
          data-testid="get-money-back-button"
          className={classes.ctaButton}
        >
          {content.cta}
        </ColorButton>
      </div>
    </div>
  </FullWidthContainer>
)

export default DiscountCard
